<template>
    <div class="p-4 rounded-md">
        <div
            class="mb-4 w-full h-70 bg-black flex flex-column justify-center rounded-sm cursor-pointer relative"
            @click="onClick"
        >
            <span v-if="testimonial.getVideoDuration()" class="text-white text-sm absolute right-0 bottom-0 p-2">
                {{ testimonial.getVideoDuration() }}</span
            >

            <div v-if="testimonial.video.thumbnail">
                <img :src="testimonial.getVideoThumbnail()" class="h-full object-contain rounded-sm p-1" />
            </div>

            <div v-else class="h-full flex-column justify-items-center content-center">
                <img :src="noImage" class="h-1/3 object-contain rounded-sm p-1" />
                <span class="text-gray-400 text-lg">Thumbnail not found</span>
            </div>
        </div>
        <div class="flex flex-col justify-between items-start gap-2">
            <div class="flex flex-row w-full justify-between items-center">
                <div class="text-xl font-medium text-surface-900 dark:text-surface-0 cursor-pointer" @click="onClick">
                    {{ testimonial.title }}
                </div>
                <VisibilityIcon :testimonial="testimonial"></VisibilityIcon>
            </div>

            <div class="flex flex-row flex-wrap gap-2">
                <Tag severity="info">
                    <span v-tooltip="'Author'">{{ testimonial.displayName() }}</span>
                </Tag>

                <Tag severity="secondary" v-tooltip="'Creation date'"> {{ testimonial.formattedDate() }}</Tag>
            </div>

            <div v-if="testimonial.products?.length" class="flex flex-row flex-wrap gap-2">
                <Tag
                    v-for="(item, index) in testimonial.products"
                    :key="index"
                    severity="success"
                    v-tooltip="'Product'"
                >
                    {{ item.name }}
                </Tag>
            </div>

            <div v-if="testimonial.industries.length" class="flex flex-row flex-wrap gap-2">
                <Tag
                    v-for="(item, index) in testimonial.industries"
                    :key="index"
                    severity="contrast"
                    v-tooltip="'Industry'"
                >
                    {{ item.name }}
                </Tag>
            </div>
        </div>
    </div>

    <PlayerDialog
        v-if="visible"
        v-model:visible="visible"
        :testimonialId="testimonial.id"
        :showShare="true"
    ></PlayerDialog>
</template>

<script setup>
import { defineProps, ref } from "vue";
import PlayerDialog from "./PlayerDialog.vue";
import noImage from "@/assets/no_thumbnail.png";
import VisibilityIcon from "@/shared/common/VisibilityIcon.vue";
import { Tag } from "primevue";

const props = defineProps({
    testimonial: {},
});

const visible = ref(false);

const url = process.env.VUE_APP_API_URL;

const onClick = () => {
    visible.value = true;
};
</script>

<style scoped></style>
